import { render, staticRenderFns } from "./BillingProductsTable.vue?vue&type=template&id=59824228&scoped=true&"
import script from "./BillingProductsTable.vue?vue&type=script&lang=js&"
export * from "./BillingProductsTable.vue?vue&type=script&lang=js&"
import style0 from "./BillingProductsTable.vue?vue&type=style&index=0&id=59824228&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59824228",
  null
  
)

export default component.exports